import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import tabsStyle from './tabs.module.css';

const Tabs = ({
  tabs,
  selectedTab,
  handleTabClick,
  setSelectedTabObject = () => {},
}) => {
  const handleKeyDown = (event, key) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTabClick(key);
    }
  };

  return (
    <Grid container className={tabsStyle.tab_container}>
      {tabs.map(tab => (
        <Box
          key={tab.key}
          tabIndex={0}
          className={tabsStyle.tab_sub_container}
          onKeyDown={event => handleKeyDown(event, tab.key)}
          onClick={() => {
            handleTabClick(tab?.key);
            setSelectedTabObject(tab);
          }}
          sx={{
            backgroundColor: selectedTab === tab.key ? '#FDF0E9' : '#FFFFFF',
            border:
              selectedTab === tab.key
                ? '1px solid #FDE7DA'
                : '1px solid #E4E4E4',
          }}>
          <Box
            className="text-regular-16px"
            sx={{
              color: selectedTab === tab.key ? '#F37021' : '#7D778C',
              textTransform: 'none',
            }}>
            {tab.value}
          </Box>
        </Box>
      ))}
    </Grid>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  selectedTab: PropTypes.string.isRequired,
  handleTabClick: PropTypes.func.isRequired,
  setSelectedTabObject: PropTypes.func,
};

export default Tabs;
